module.exports = __webpack_public_path__ + "static/media/twitterfeeds.d9962b8b.png";